export default "__VITE_ASSET__7aab12bb__"